import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { HelplineData, IStrapiDocuments } from 'src/app/interfaces/strapi';
import { Residence } from 'src/app/shared/models/residence.model';
import StrapiService from 'src/app/services/strapi.service';
import { NgClass, NgIf } from '@angular/common';
import { AuthService } from '../../../services/auth.service';

@Component({
    selector: 'app-wellbeing-helpline',
    templateUrl: './wellbeing-helpline.component.html',
    styleUrls: ['./wellbeing-helpline.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgClass, NgIf],
})
export class WellbeingHelplineComponent implements OnInit {
  @Input() alternateColours = false;

  public helplineData: HelplineData = <HelplineData>{};

  public userAccommodation: Residence = <Residence>{};

  constructor(
    private readonly auth: AuthService,
    private readonly strapi: StrapiService,
    private readonly cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.userAccommodation = <Residence>this.auth.currentUser?.accommodation;
    this.strapi
      .getDocumentByUID('helplines', 'helplines')
      .subscribe((data: IStrapiDocuments<HelplineData>) => {
        this.helplineData = data.data[0].attributes;
        this.cdr.markForCheck();
      });
  }
}
